module.exports = __webpack_public_path__ + "static/media/darkova-krabicka-logo-pink.a5c479d3.svg";